const styles = () => {
  return {
    root: {
      display: 'flex'
    },
    form: {
      marginLeft: '20px',
      width: '45vw',
      height: '80vh',
      backgroundColor: '#FFF',
      padding: '10px',
      overflow: 'auto'
    },
    radioRow: {
      display: 'flex',
      width: '45vw',
      alignItems: 'center',
      paddingLeft: '10px',
      backgroundColor: '#FFF'
    },
    radioButtons: {
      paddingLeft: '10px'
    },
    nameContainer: {
      width: '45vw',
      backgroundColor: '#FFF',
      padding: '10px',
      display: 'flex',
      alignItems: 'center',
      fontWeight: 600
    },
    nameLabel: { marginRight: '10px' },
    textfield: {
      width: '250px'
    },
    boxRow: { display: 'flex', justifyContent: 'space-between' }
  };
};

export default styles;

export const customSelectStyles = {
  option: {
    fontSize: '12px'
  },
  control: {
    width: '250px'
  },
  menu: {
    width: '250px'
  }
};
